import { Outlet } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

/**
 * Minimal layout for auth-transition pages on dwrrah.com:
 *   - /post-login         (OAuth / handoff arrival)
 *   - /complete-profile   (gated profile completion)
 *   - /reset-password     (deep-linked reset arrival)
 *
 * These pages are NOT marketing surfaces. When a student logs in via a
 * custom-domain academy and OAuth bounces them through dwrrah.com/post-login,
 * they should NOT see Dwrrah's pricing/features header & footer. This layout
 * provides a neutral background and renders only the matched child route —
 * the page itself supplies its own spinner / form / messaging.
 *
 * Keeps the global theme (dir, fonts, semantic tokens) but strips chrome.
 */
export default function AuthTransitionLayout() {
  const { dir } = useI18n();
  return (
    <div
      dir={dir}
      className="min-h-screen flex flex-col bg-background text-foreground"
    >
      <main className="flex-1 flex items-center justify-center px-4">
        <Outlet />
      </main>
    </div>
  );
}